import React, { Component } from 'react'
import Card from '@mui/material/Card'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import ArrowDropDown from '@mui/icons-material/ArrowDropDown'
import ArrowDropUp from '@mui/icons-material/ArrowDropUp'
import Tooltip from '@mui/material/Tooltip'
import _ from 'lodash'

import styles from './VisaoPorAuditorItensAcessadosCard.module.css'
import { visualizarUrlSistemaLinksPrincipais } from '../../../controllers/itensController'

const ID_SIST_PROCESSOS = 'processos'
const TIPO_PROCESSO_CE = 'PROCESSO_CE'
const ID_SIST_PROCESSOS_ADM = 'processos-adm'
const TIPO_PROCESSO_ADM = 'PROCESSO_ADM'
const ID_SIST_COMUNICACOES = 'comunicacoes'
const TIPO_COMUNICACAO = 'COMUNICACAO'
const ID_SIST_DOCUMENTOS = 'documentos'
const TIPO_DOCUMENTO = 'DOCUMENTO'
const TIPO_REGISTRO_ENTRADA = 'REGISTRO_ENTRADA'

const idsSistemasPorTipoItem = {
  [TIPO_PROCESSO_CE]: { sistema: ID_SIST_PROCESSOS, objetoURL: 'processos' },
  [TIPO_PROCESSO_ADM]: { sistema: ID_SIST_PROCESSOS_ADM, objetoURL: 'processos' },
  [TIPO_COMUNICACAO]: { sistema: ID_SIST_COMUNICACOES, objetoURL: 'comunicacoes' },
  [TIPO_DOCUMENTO]: { sistema: ID_SIST_DOCUMENTOS, objetoURL: 'documentos' },
  [TIPO_REGISTRO_ENTRADA]: { sistema: ID_SIST_DOCUMENTOS, objetoURL: 'registros-entrada' }
}

const MAX_ITENS_POR_LINHA = 3

export class VisaoPorAuditorItensAcessadosCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      exibirTodosItens: false
    }
    this.handleShowItensIconButtonClick = this.handleShowItensIconButtonClick.bind(this)
    this.handleHideItensIconButtonClick = this.handleHideItensIconButtonClick.bind(this)
  }

  handleItemAcessadoUsuarioGridClick(codigo, tipo) {
    const sistemaTipo = idsSistemasPorTipoItem[tipo]

    const callback = (url) =>
      window.open(`${url}?redirectTo=/${sistemaTipo.objetoURL}/codigo/${codigo}`, '_blank')
    visualizarUrlSistemaLinksPrincipais(sistemaTipo.sistema, callback)
  }

  handleHideItensIconButtonClick() {
    this.setState({ exibirTodosItens: false })
  }

  handleShowItensIconButtonClick() {
    this.setState({ exibirTodosItens: true })
  }

  renderItem({ codigo, codigoItem, descricao, tipo, assuntoItem }) {
    return (
      <Box
        p={1}
        style={{ maxWidth: 'calc(33% - 8px)' }}
        key={codigo}
        onClick={() => this.handleItemAcessadoUsuarioGridClick(codigoItem, tipo)}>
        <Tooltip title={_.toUpper(assuntoItem)} placement='bottom'>
          <Typography className={styles.linkEstilo} noWrap>
            {_.toUpper(descricao)}
          </Typography>
        </Tooltip>
      </Box>
    )
  }

  renderItensHeader() {
    const { historicosItensAcessadosUsuario } = this.props
    return _.map(_.slice(historicosItensAcessadosUsuario, 0, MAX_ITENS_POR_LINHA), (hist) =>
      this.renderItem(hist)
    )
  }

  renderItensGridList() {
    const { historicosItensAcessadosUsuario } = this.props
    const { exibirTodosItens } = this.state
    return exibirTodosItens
      ? _.map(_.slice(historicosItensAcessadosUsuario, MAX_ITENS_POR_LINHA), (hist) =>
          this.renderItem(hist)
        )
      : null
  }

  renderItensBody() {
    const { historicosItensAcessadosUsuario } = this.props
    return _.size(historicosItensAcessadosUsuario) > MAX_ITENS_POR_LINHA ? (
      <React.Fragment>{this.renderItensGridList()}</React.Fragment>
    ) : null
  }

  render() {
    const { historicosItensAcessadosUsuario } = this.props
    const { exibirTodosItens } = this.state
    const size = _.size(historicosItensAcessadosUsuario)
    return (
      <Card style={{ borderRadius: '14px', padding: '11px 16px', position: 'relative' }}>
        <Box display='flex' alignItems='center' flexWrap='wrap'>
          <Box width={90}>
            <Typography color='textPrimary' className={styles.labelRecentes}>
              Acessados recentemente
            </Typography>
          </Box>
          {size ? (
            <React.Fragment>
              <Box width={'calc(100% - 121px)'} display='flex' flexWrap='wrap'>
                {this.renderItensHeader()}
              </Box>
              <Box width={30} className={styles.botaoExpandir}>
                <IconButton
                  size='small'
                  onClick={
                    !exibirTodosItens
                      ? this.handleShowItensIconButtonClick
                      : this.handleHideItensIconButtonClick
                  }>
                  {!exibirTodosItens ? <ArrowDropDown /> : <ArrowDropUp />}
                </IconButton>
              </Box>
            </React.Fragment>
          ) : null}
          <Box flexGrow={1} display='flex' flexWrap='wrap'>
            {size ? (
              this.renderItensBody()
            ) : (
              <Box>
                <Typography variant='caption' color='textPrimary'>
                  Não foram registrados itens acessados recentemente ainda.
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Card>
    )
  }
}

export default VisaoPorAuditorItensAcessadosCard
